import React from "react";
import APrecisionTool from "web/assets/images/a-precision-tool.png";
import ConsolidatePurchase from "web/assets/images/consolidate-purchase.png";
import BidDailyWeekely from "web/assets/images/bid-daily-weekely.png";
import PromoteInternalTrade from "web/assets/images/promote-internal-trade.png";
import PrivateGroups from "web/assets/images/private-groups.png";
import ExtendYourReach from "web/assets/images/extend-your-reach.png";
import ReduceCosts from "web/assets/images/reduce-costs.png";
import QualifiedSellers from "web/assets/images/qualified-sellers.png";
import ConnectMultipleFacilities from "web/assets/images/connect-multiple-facilities.png";
import BuyLocal from "web/assets/images/buy-local.png";
import { useHistory } from 'react-router-dom';

import {
  Container,
  Wrapper,
  GroupSection,
  BoxSection,
} from "web/pages/public/landing-page/WhoItFor/PalletBuyers/PalletBuyersStyled";
const Data = [
  {
    id: 1,
    heading: "A Precision Tool",
    subHeading:
      "Precision and productivity. Your highly-targeted bids and requests will reach a larger pallet industry audience.",
    src: `${APrecisionTool}`,
  },
  {
    id:12,
    heading: "Control Costs",
    subHeading:
      "Market intelligence ensures smarter buying and selling. Control costs for procuring cores essential to maintaining inventory.",
    src: `${ReduceCosts}`,
  },
  {
    id: 4,
    heading: "A New Way to RFP",
    subHeading:
      "It’s easy to avoid cumbersome procurement events. Bid every day, or bid automatically, daily or weekly, as often as you need.",
    src: `${BidDailyWeekely}`,
  },
  {
    id: 6,
    heading: "Extend Your Reach",
    subHeading:
      "PalletTrader gives buyers increased reach, options, and market insight beyond the one, local supplier around the corner.",
    src: `${ExtendYourReach}`,
  },
  {
    id: 9,
    heading: "Connect Multiple Facilities",
    subHeading:
      "Corporations can develop a national program, allowing divisions or locations to operate within the corporate master with permissions visibility.",
    src: `${ConnectMultipleFacilities}`,
  },
  {
    id: 7,
    heading: "Qualified Sellers",
    subHeading:
      "PalletTrader will qualify sellers. Our vetting process ensures members are the highest-quality trading partners.",
    src: `${QualifiedSellers}`,
  },
  {
    id: 3,
    heading: "Consolidate Purchase",
    subHeading:
      "With PalletTrader, you can simply and efficiently consolidate your corporate pallet purchases.",
    src: `${ConsolidatePurchase}`,
  },
  {
    id: 5,
    heading: "Promote Internal Trade",
    subHeading:
      "Captive or semi-captive pallet pool partners can share visibility of on-hand, excess pallet inventory, expediting internal exchange.",
    src: `${PromoteInternalTrade}`,
  },
  {
    id: 10,
    heading: "Buy Local",
    subHeading:
      "Corporations who want to reach and buy local now have a method previously unavailable, eliminating one-off procurement hurdles.",
    src: `${BuyLocal}`,
  },
   
  {
    id: 13,
    heading: "Private Groups",
    subHeading:
      "PalletTrader enables private transactions with your suppliers for ultimate go-to-market flexibility. Post your pallet needs to the marketplace, or to one of your private groups.",
    src: `${PrivateGroups}`,
  },
  
];

const PalletBuyers = () => {
  let history = useHistory();
  const signUp = () => {
    history.push('/registration')
  }
return (
  <Container data-aos="fade-up" data-aos-delay="600">
    <Wrapper>
      <h4 className="blue-text">Pallet Buyers.</h4>
      <h4>
        Extend your pallet supply options. Around the corner, or around the
        country.
      </h4>
      <h5>
        Geographic intelligence makes it possible to specify the area that best
        meets your buying needs. Comprehensive listing options let you select
        the type of pallet, materials, condition, pick-up or delivery details,
        and more. Post your search, and your RFP process just got a 21st century
        upgrade.
      </h5>
      <GroupSection>
        {Data.map((e) => {
          return (
            <BoxSection key={e.id}>
              <img src={e.src} alt="NounPins"/>
              <h6>{e.heading}</h6>
              <p>{e.subHeading}</p>
            </BoxSection>
          );
        })}
      </GroupSection>
      <button onClick={signUp}>Sign Me Up</button>
    </Wrapper>
  </Container>
);}

export default PalletBuyers;
